/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export enum CategoryFilterLayout {
  Default = "DEFAULT",
  Vertical = "VERTICAL",
  Horizontal = "HORIZONTAL",
  None = "NONE",
}
